import { Text } from "@/components/ui/Text";
import { useDonationFormStore } from "@/stores";
import { formatCurrency } from "@/utils/formatters";

export function DonationAmountConfirmation() {
  const donationAmount = useDonationFormStore((state) => state.donationAmount);

  if (donationAmount === null) return null;

  return <Text>Donation amount: {formatCurrency(donationAmount)}</Text>;
}
